import { render, staticRenderFns } from "./ItsCustomsDeclearationFee.vue?vue&type=template&id=64cc28a2&scoped=true&"
import script from "./ItsCustomsDeclearationFee.vue?vue&type=script&lang=js&"
export * from "./ItsCustomsDeclearationFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cc28a2",
  null
  
)

export default component.exports